module.exports = __webpack_public_path__ + "img/cutaway_driving.85b651f1.svg";